import {
    SHOW_DIALOGUE_WITH_PROPS,
    HIDE_DIALOGUE_BOX
} from "./actionConstants"

export const showDialogueBox = (payload) => ({
    type: SHOW_DIALOGUE_WITH_PROPS,
    payload
});

export const hideDialogueBox = () => ({
    type: HIDE_DIALOGUE_BOX
});